<!-- 最近30天异常情况 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <a-col :span="24" style="height: 32%">
        <div style="text-align: left;font-size: 15px;color: aqua;">{{ $t('故障设备排名') }}</div>
        <Echart ref="option1" :options="option1" style="height: calc(100% - 20px)"></Echart>
      </a-col>
      <a-col :span="24" style="height: 34%">
        <div style="text-align: left;font-size: 15px;color: aqua;">{{ $t('故障隐患趋势') }}</div>
        <Echart ref="option2" :options="option2" style="height: calc(100% - 20px)"></Echart>
      </a-col>
      <a-col :span="24" style="height: 34%">
        <div style="text-align: left;font-size: 15px;color: aqua;">{{ $t('故障设备分布') }}</div>
        <Echart ref="option3" :options="option3" style="height: calc(100% - 20px)"></Echart>
      </a-col>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  // import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('最近30天异常情况'),
        url: {
          LargeScreenSumDeviceAnomalyRankingByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyRankingByTime",//异常排名
          LargeScreenSumDeviceAnomalyTrendByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyTrendByTime",//异常趋势
          LargeScreenSumDeviceAnomalyTypeByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumDeviceAnomalyTypeByTime",//异常分布
        },
        option1: {},
        option2: {},
        option3: {},
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData1();
        this.getData2();
        this.getData3();
      },
      getData1(){
        postAction(this.url.LargeScreenSumDeviceAnomalyRankingByTime,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption1(data);
          }
        })
      },
      setOption1(data) {
        let seriesData = []
        let y1 = [];
        let y2 = [];
        data.map(item=>{
          y1.push(item.num);
          y2.push(item.deviceName);
        });
        seriesData[0] = {
          name: this.$t('实际巡检'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: y1
        }
        this.$refs.option1.hideLoading()
        this.option1 = {
          color: ['#50E3C2'],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
          },
          legend: {
            show: false,
            type: 'scroll',
            textStyle: {
              color: '#CEE2FF'
            },
            // icon: 'circle',
            itemHeight: 10,
            right: 0,
            // pageIconColor: '#aaa',
            // pageIconInactiveColor: '#2f4554',
            // pageTextStyle: {
            //   color: 'rgb(91, 135, 195)'
            // }
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: true,
            
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [
            {
              type: 'category',
              name: '',
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              },
              data: y2,
            }
          ],
          series: seriesData
        };
      },
      getData2(){
        postAction(this.url.LargeScreenSumDeviceAnomalyTrendByTime,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption2(data);
          }
        })
      },
      setOption2(data) {
        let seriesData = []
        let y1 = [];
        let y2 = [];
        data.map(item=>{
          y1.push(item.num);
          y2.push(item.time);
        });
        seriesData[0] = {
          name: '',
          type: 'line',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: y1,
          areaStyle: {}
        }
        this.$refs.option2.hideLoading()
        this.option2 = {
          color: ['#0394FF'],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
          },
          legend: {
            show: false,
            type: 'scroll',
            textStyle: {
              color: '#CEE2FF'
            },
            itemHeight: 10,
            right: 0,
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: y2,
            boundaryGap: true,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('单位:个'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              },
            }
          ],
          series: seriesData
        };
      },
      getData3(){
        postAction(this.url.LargeScreenSumDeviceAnomalyTypeByTime,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption3(data);
          }
        })
      },
      // setOption3(data) {
      //   let seriesData = []
      //   let legendData = []
      //   data.map(item=>{
      //     seriesData.push({
      //       name: item.deviceName,
      //       value: item.num
      //     })
      //     legendData.push(item.deviceName);
      //   });
      //   for(let i=0;i<data.length;i++){
      //     seriesData.push({
      //       name: '',
      //       value: 0
      //     })
      //   }
      //   this.$refs.option3.hideLoading()
      //   this.option3 = {
      //     color: ['#FECA20', '#50E3C2', '#FA6400', '#0091FF'],
      //     title: {
      //       show: false
      //     },
      //     tooltip: {
      //       trigger: 'item',
      //       formatter: '{a} <br/>{b} : {c} ({d}%)'
      //     },
      //     legend: {
      //       type: 'scroll',
      //       show: true,
      //       left: 'left',
      //       top: 'top',
      //       icon: 'circle',
      //       itemHeight: 8,
      //       textStyle: {
      //         color: '#CEE2FF',
      //         fontSize: '12px'
      //       },
      //       data: legendData
      //     },
      //     grid: {
      //       left: '3%',
      //       right: '3%',
      //       bottom: '3%',
      //       containLabel: true
      //     },
      //     series: [
      //       {
      //         name: '故障设备分布',
      //         type: 'pie',
      //         radius: ['20%', '70%'],
      //         center: ['50%', '30%'],
      //         // itemStyle: {
      //         //   borderRadius: 5
      //         // },
      //         startAngle: 0,
      //         roseType: 'area',
      //         // endAngle: 180,
      //         label:{
      //           show: false,
      //           color: '#fff',
      //           formatter: function(params) {
      //             return `${params.name}:${params.value}`
      //           },
      //         },
      //         data: seriesData
      //       }
      //     ]
      //   };
      // },
      setOption3(data){
        let scaleData = []
        let legendData = []
        data.map(item=>{
          scaleData.push({
            name: item.deviceName,
            value: item.num
          })
          legendData.push(item.deviceName);
        });
        var placeHolderStyle = {
            normal: {
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0
            }
        };
        var data = [];
        var color = ['rgb(255, 176, 63)', 'rgb(61, 186, 45)', 'rgb(43, 166, 254)','rgb(255, 153, 153)'];
        var colorBorder = [ 'rgba(255, 176, 63, 0.4)', 'rgba(61, 186, 45, 0.4)', 'rgba(43, 166, 254, 0.4)','rgba(255, 153, 153, 0.4)'];
        for (var i = 0; i < scaleData.length; i++) {
            data.push({
                data: scaleData[i].value,
                value: 20,
                name: scaleData[i].name,
                itemStyle: {
                    normal: {
                        color: color[i],
                        borderWidth: 20,
                        borderColor: colorBorder[i]
                    }
                }
            }, {
                value: 8,
                name: '',
                itemStyle: placeHolderStyle
            });
        }
        data.push({
            value: 40,
            name: '',
            itemStyle: placeHolderStyle
        })
        var seriesObj = [{
            name: '',
            type: 'pie',
            clockWise: false,
            radius: ['20%', '70%'],
            hoverAnimation: false,
            startAngle: -30,
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                        position: 'inner',
                        fontSize: 14,
                        lineHeight: 15,
                        formatter: function(params) {
                            var percent = 0;
                            var total = 0;
                            for (var i = 0; i < scaleData.length; i++) {
                                total += scaleData[i].value;
                            }
                            percent = ((params.value / total) * 100).toFixed(0);
                            if (params.name !== '') {
                                // return params.name + '\n' + params.data.data;
                                if (params.name.length > 4) {
                                    return params.name.slice(0, 3) + '\n' + params.name.slice(3);
                                } else {
                                    return params.name;
                                }
        
                            } else {
                                return '';
                            }
                        }
                    },
                    labelLine: {
                        length: 30,
                        length2: 60,
                        show: true
                    }
                }
            },
            data: data
        }, {
            name: '',
            type: 'pie',
            clockWise: false,
            radius: ['20%', '70%'],
            hoverAnimation: false,
            startAngle: -30,
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                        position: 'outside',
                        fontSize: 18,
                        formatter: function(params) {
                            var percent = 0;
                            var total = 0;
                            for (var i = 0; i < scaleData.length; i++) {
                                total += scaleData[i].value;
                            }
                            percent = ((params.value / total) * 100).toFixed(0);
                            if (params.name !== '') {
                                return params.data.data;
                            } else {
                                return '';
                            }
                        }
                    },
                    labelLine: {
                        length: 30,
                        length2: 60,
                        show: true
                    }
                }
            },
            data: data
        }];
        this.$refs.option3.hideLoading()
        this.option3 = {
            tooltip: {
                show: false
            },
            legend: {
                show: false
            },
            toolbox: {
                show: false
            },
            grid: {
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
            },
            series: seriesObj,
        }
      }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }
</style>